import React, { useContext } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import { ProductCollection } from '../../../../types';

import * as S from './styles';

const SitemapLink = ({
  productCollection,
}: {
  productCollection?: ProductCollection;
}) => {
  const { linkTo, t } = useContext(AppContext);
  const productCollectionUrl = productCollection?.url;
  const sitemapUrl = productCollectionUrl
    ? linkTo('productCollectionSitemap', {
        baseUrl: productCollectionUrl,
      })
    : null;
  const headerBlockSlice: any = productCollection?.slices?.find(
    slice => slice.__typename === 'HeaderBlockSlice'
  );
  const productCollectionTitle = headerBlockSlice ? headerBlockSlice.title : '';
  return sitemapUrl && productCollectionTitle ? (
    <S.HeaderLink to={sitemapUrl}>
      {t('category', 'product-collection.sitemap-link', {
        productCollectionTitle,
      })}
    </S.HeaderLink>
  ) : null;
};

export default SitemapLink;
